import { computed, Ref } from 'vue';
import { getJwtExpiry, getJwtTimeLeftMs, isJwtExpired } from '@/utils/jwt.ts';

export function useJwtInfo(token: string | null) {
  const expiryDate = computed(() => (token ? getJwtExpiry(token) : null));
  const timeLeftMs = computed(() => (token ? getJwtTimeLeftMs(token) : null));
  const expired = computed(() => (token ? isJwtExpired(token, 30) : true)); // 30s Leeway

  // Praktisch für UI: Minuten verbleibend
  const secondsLeft = computed(() => (timeLeftMs.value == null ? null : Math.max(0, Math.floor(timeLeftMs.value / 1000))));
  const minutesLeft = computed(() => (timeLeftMs.value == null ? null : Math.max(0, Math.floor(timeLeftMs.value / 60000))));

  return { expiryDate, timeLeftMs, secondsLeft, minutesLeft, expired };
}
